export default {
  zh: {
    ipWhiteLists: 'IP白名单',
    addIpWhiteLists: '增加IP白名单',
    editIpWhiteLists: '修改IP白名单',
    action: '操作',
    ipAddress: 'IP地址',
    createdAt: '创建时间',
    ipStatus: 'IP状态',
    comment: '评论',
    actived: '已激活',
    inActived: '待用',
    errorMsg: '缺少必填项',
  },
  en: {
    ipWhiteLists: 'IP White Lists',
    addIpWhiteLists: 'Add Ip White Lists',
    editIpWhiteLists: 'Edit Ip White Lists',
    action: 'Action',
    ipAddress: 'IP Address',
    createdAt: 'Created Time',
    ipStatus: 'IP Status',
    comment: 'Comment',
    actived: 'Active',
    inActived: 'Inactive',
    errorMsg: 'Feilds need to fill',
  },
};



// WEBPACK FOOTER //
// ./src/views/Setup/IpWhiteLists/i18n.js